import { render, staticRenderFns } from "./OnlineOrderModifierGroupData.vue?vue&type=template&id=f5537714&"
import script from "./OnlineOrderModifierGroupData.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderModifierGroupData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports